import type { HelpArticle } from './help-content';

function normalize(value: string, locale: string): string {
  return value
    .normalize('NFKD')
    .replace(/\p{Mark}+/gu, '')
    .replaceAll('ß', 'ss')
    .toLocaleLowerCase(locale)
    .replace(/[^\p{Letter}\p{Number}]+/gu, ' ')
    .trim();
}

export function tokenizeHelpSearch(value: string, locale: string): readonly string[] {
  return normalize(value, locale).split(/\s+/u).filter(Boolean);
}

export function searchHelp(
  articles: readonly HelpArticle[],
  query: string,
  locale: string,
): readonly HelpArticle[] {
  const tokens = tokenizeHelpSearch(query, locale);
  if (tokens.length === 0) return articles;
  return articles
    .map((article) => {
      const title = normalize(article.metadata.title, locale);
      const searchable = normalize(
        [
          article.metadata.title,
          article.metadata.description,
          ...article.metadata.keywords,
          article.body,
        ].join(' '),
        locale,
      );
      const matches = tokens.filter((token) => searchable.includes(token));
      const score =
        matches.length * 10 + tokens.filter((token) => title.includes(token)).length * 5;
      return { article, score, complete: matches.length === tokens.length };
    })
    .filter((entry) => entry.complete)
    .sort(
      (left, right) =>
        right.score - left.score ||
        left.article.metadata.title.localeCompare(right.article.metadata.title, locale),
    )
    .map((entry) => entry.article);
}
